import React, { useState, useEffect } from 'react';
import './CreditsModal.css';

const CreditsModal = ({ isOpen, onClose }) => {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen) {
      loadSubmissions();
    }
  }, [isOpen]);

  const formatName = (name) => {
    if (!name) return 'Anonymous';
    
    // Convert camelCase to readable format
    // e.g., "johnSmith" -> "John Smith"
    return name
      .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capital letters
      .replace(/^./, str => str.toUpperCase()) // Capitalize first letter
      .trim();
  };

  const loadSubmissions = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch('/api/photo-submissions');
      
      if (!response.ok) {
        throw new Error('Failed to load submissions');
      }

      const data = await response.json();
      setSubmissions(data.submissions || []);
    } catch (err) {
      console.error('Error loading submissions:', err);
      setError('Failed to load photo submissions');
      setSubmissions([]);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="credits-overlay">
      <div className="credits-modal">
        <div className="credits-header">
          <h2>🌟 Community Contributors 🌟</h2>
          <p className="credits-subtitle">Celebrating the amazing players who shared their photos!</p>
          <button className="credits-close-btn" onClick={onClose}>×</button>
        </div>

        <div className="credits-content">
          {loading ? (
            <div className="credits-loading">
              <div className="loading-spinner"></div>
              <p>Loading amazing contributions...</p>
            </div>
          ) : error ? (
            <div className="credits-error">
              <h3>❌ {error}</h3>
              <button onClick={loadSubmissions}>Try Again</button>
            </div>
          ) : submissions.length > 0 ? (
            <div className="submissions-grid">
              {submissions.map((submission, index) => (
                <div key={index} className="submission-card">
                  <div className="submission-image">
                    <img 
                      src={submission.imageUrl} 
                      alt={submission.description}
                      loading="lazy"
                      decoding="async"
                      onLoad={() => console.log(`✅ Contributor image loaded: ${submission.submitterName}`)}
                      onError={(e) => {
                        console.error(`❌ Contributor image failed: ${submission.submitterName}`);
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'block';
                      }}
                    />
                    <div className="image-fallback" style={{ display: 'none' }}>
                      <span>📷</span>
                    </div>
                  </div>
                  <div className="submission-info">
                    <h3 className="contributor-name">{formatName(submission.submitterName)}</h3>
                    <p className="submission-description">"{submission.description}"</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-submissions">
              <h3>🎨 No submissions yet!</h3>
              <p>Be the first to contribute your photos to the community!</p>
            </div>
          )}
        </div>

        <div className="credits-footer">
          <p className="credits-note">
            Thank you to all contributors! Your photos make the game more fun for everyone! 🎉
          </p>
        </div>
      </div>
    </div>
  );
};

export default CreditsModal;
